import React, { useEffect, useState } from "react";
import {
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  Table,
  Row,
  Col,
  Badge,
  Spinner,
} from "reactstrap";
import axios from "axios";
import swal from "sweetalert";
import { API_DONOR_STATISTIK, API_TIMEOUT } from "utils";

function DonorStatistik() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  const formatTanggalIndonesia = (tanggal) => {
    if (!tanggal) return "-";
    const date = new Date(tanggal);
    const bulan = [
      "Januari",
      "Februari",
      "Maret",
      "April",
      "Mei",
      "Juni",
      "Juli",
      "Agustus",
      "September",
      "Oktober",
      "November",
      "Desember",
    ];
    const hari = date.getDate();
    const bulanIndex = date.getMonth();
    const tahun = date.getFullYear();
    return `${hari} ${bulan[bulanIndex]} ${tahun}`;
  };

  const fetchData = async () => {
    setLoading(true);
    try {
      const res = await axios.get(API_DONOR_STATISTIK, {
        timeout: API_TIMEOUT,
      });
      if (res.data?.success) {
        setData(res.data.data || []);
      } else {
        swal("Error", res.data?.message || "Gagal mengambil data", "error");
      }
    } catch (error) {
      const msg =
        error.response?.data?.message ||
        error.message ||
        "Terjadi kesalahan saat mengambil data";
      swal("Error", msg, "error");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <div className="content">
      <Row>
        <Col md="12">
          <Card>
            <CardHeader>
              <CardTitle tag="h4">Statistik Pendonor (darah_masuk)</CardTitle>
              <p className="card-category">
                Diurutkan dari jumlah donor terbanyak ke paling sedikit. Hanya
                pendonor yang sudah pernah donor ditampilkan.
              </p>
            </CardHeader>
            <CardBody>
              <Table responsive>
                <thead className="text-primary">
                  <tr>
                    <th>No</th>
                    <th>Nama</th>
                    <th>Gol. Darah</th>
                    <th>No. HP</th>
                    <th>Desa</th>
                    <th>Tanggal Donor</th>
                    <th>Kali Donor</th>
                    <th>Total Kantong</th>
                  </tr>
                </thead>
                <tbody>
                  {loading ? (
                    <tr>
                      <td colSpan="8" className="text-center">
                        <Spinner size="sm" color="primary" /> Memuat...
                      </td>
                    </tr>
                  ) : data.length === 0 ? (
                    <tr>
                      <td colSpan="8" className="text-center">
                        Belum ada data donor.
                      </td>
                    </tr>
                  ) : (
                    data.map((item, index) => (
                      <tr key={item.donor_id || index}>
                        <td>{index + 1}</td>
                        <td>{item.nama || "-"}</td>
                        <td>
                          <Badge color="info">
                            {item.golonganDarah || "-"}
                          </Badge>
                        </td>
                        <td>{item.noHp || "-"}</td>
                        <td>{item.desa || "-"}</td>
                        <td>
                          {formatTanggalIndonesia(item.tanggal_donor_terakhir)}
                        </td>
                        <td>{item.total_donor || 0}</td>
                        <td>{item.total_kantung || 0}</td>
                      </tr>
                    ))
                  )}
                </tbody>
              </Table>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </div>
  );
}

export default DonorStatistik;
